import React from "react";
import { toast } from "sonner";
import { XLogo, FacebookLogo, LinkSimple, ShareNetwork } from "@phosphor-icons/react";

const openPopup = (url) => window.open(url, "_blank", "noopener,noreferrer,width=600,height=500");

export const ShareButtons = ({ url, text, lang }) => {
  const cs = lang === "cs";
  const shareX = () =>
    openPopup(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`);
  const shareFb = () =>
    openPopup(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(text)}`);
  const copyLink = async () => {
    const legacy = () => {
      try {
        const ta = document.createElement("textarea");
        ta.value = url;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand("copy");
        ta.remove();
        return ok;
      } catch {
        return false;
      }
    };
    let ok = false;
    try {
      await navigator.clipboard.writeText(url);
      ok = true;
    } catch {
      ok = legacy();
    }
    if (ok) toast.success(cs ? "Odkaz zkopírován" : "Link copied");
    else toast.error(cs ? "Kopírování selhalo" : "Copy failed");
  };
  const nativeShare = async () => {
    try {
      await navigator.share({ title: text, text, url });
    } catch (e) {
      if (e?.name !== "AbortError") toast.error(cs ? "Sdílení selhalo" : "Share failed");
    }
  };

  const btn = "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium bg-zinc-900 hover:bg-zinc-800 border border-zinc-800 text-zinc-300 transition-colors";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-buttons">
      <button onClick={shareX} data-testid="share-x-btn" className={btn} aria-label="Sdílet na X">
        <XLogo weight="bold" size={14} /> X
      </button>
      <button onClick={shareFb} data-testid="share-facebook-btn" className={btn} aria-label="Sdílet na Facebooku">
        <FacebookLogo weight="bold" size={14} /> Facebook
      </button>
      <button onClick={copyLink} data-testid="share-copy-btn" className={btn}>
        <LinkSimple weight="bold" size={14} /> {cs ? "Kopírovat odkaz" : "Copy link"}
      </button>
      {typeof navigator !== "undefined" && !!navigator.share && (
        <button onClick={nativeShare} data-testid="share-native-btn" className={btn}>
          <ShareNetwork weight="bold" size={14} /> {cs ? "Sdílet" : "Share"}
        </button>
      )}
    </div>
  );
};
